module.exports = {
  title: 'Welcome - Rialto | Bistro Bar',
  // eslint-disable-next-line
  description: 'In Gstaad the RIALTO bids you welcome, accompanied by cordially hospitality, authenticity – and Terroir.',
  debugMode: false,
  logRedirects: false,
  // be sure to not add any / at the end of URL
  url: {
    dev: 'http://localhost:3333',
    prod: 'https://rialto.vercel.app'
  },
  api: {
    // TODO: convert to projectId: process.env.SANITY_PROJECT_ID
    projectId: '1273jw7b',
    // dataset: process.env.NODE_ENV === 'production' ? 'production' : 'develop',
    dataset: 'production',
    // Add current date to fix the data api version. This avoids breaking changes over the time.
    apiVersion: '2021-10-11',
    useCdn: true
  },
  modules: {
    // TODO: Webfontloader: https://github.com/Developmint/nuxt-webfontloader
    googleTagManager: {
      active: false,
      id: 'GTM-XXXXXXX'
    },
    googleAnalytics: {
      active: false,
      id: 'UA-XXXXXX-X'
    },
    sendgrid: {
      active: true,
      id: process.env.SENDGRID_ID
    },
    cookieConsent: {
      active: true,
      position: 'br', // tl = topleft, tr = topright, bl = bottomleft, br = bottomright
      transition: 'fl' // fd = fade, ft = fromTop, fl = fromLeft, fb = fromBottom, fr = fromRight
    }
  },
  mixins: {
    setDevmode: true,
    setViewportSizes: false
  },
  i18n: {
    baseUrl:
      process.env.NODE_ENV === 'production'
        ? 'https://rialto.vercel.app/'
        : 'http://localhost:3333/',
    strategy: 'prefix_except_default',
    vuex: {
      moduleName: 'i18n',
      syncRouteParams: true
    },
    locales: [
      {
        code: 'fr',
        iso: 'fr'
      },
      {
        code: 'en',
        iso: 'en'
      },
      {
        code: 'de',
        iso: 'de'
      }
    ],
    defaultLocale: 'de',
    detectBrowserLanguage: {
      useCookie: true,
      cookieKey: 'i18n_redirected',
      fallbackLocale: 'de',
      redirectOn: 'root'
    }
  }
};
